import {Injectable} from '@angular/core';
import {GeneralServicesImplService} from '../../../services/general-services-impl.service';
import {HttpClient} from '@angular/common/http';
import * as servers from '../../../services/api/servers';
import {urls} from '../../../services/api/urls';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ProjectConstants} from '../../project-constants';
import { ProviderModel } from 'src/models/ProviderModel';

@Injectable({
  providedIn: 'root'
})
export class ProviderAnagrafService  extends GeneralServicesImplService {

  constructor(http: HttpClient) {
    super(http);
  }

  // baseUrl: string = servers.apiUrl + urls.cobidbService + urls.provider;
  baseUrl: string = servers.apiUrl + urls.provider;

  getPage(filter: any, offset?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.PAGE;
    const body =  offset ? JSON.stringify(offset) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: filter})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getPageInAllSettings(filter: any, offset?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.PAGE_IN_ALL_SETTING;
    const body =  offset ? JSON.stringify(offset) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: filter})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getPageInAllContractMonth(filter: any, offset?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.PAGE_IN_ALL_CONTRACT_MONTH;
    const body =  offset ? JSON.stringify(offset) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: filter})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getListInArchitectureStructure(filter: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.LIST_IN_ARCHITECTURE_STRUCTURE;
    const body =  filter;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getListInContractTypeSetting(filter: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.LIST_IN_CONTRACT_TYPE_SETTING;
    const body =  filter;
    const header = ProjectConstants.returnGeneralHeader();
    console.log(JSON.stringify(filter));
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getById(providerId){
    const url = this.baseUrl + '/'+providerId;
    const header = ProjectConstants.returnGeneralHeader();
    const body = providerId ? providerId : null;
    return this.http.get( url, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  softDelete(id: number): Observable<any> {
    const url = this.baseUrl  + this.LINKS.SOFT_DELETE + id;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.delete(url, {headers: header, responseType: 'json'})
      .pipe(
        map (data => data)
      );
  }
}

